import React, {useState} from 'react';
import {ScrollView, StyleSheet, View} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {parceiroCategorias} from '../../../../dtos/ParceiroDTO';
import {SearchInput} from '../../../../components/Interface/Forms/Inputs/SearchInput';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';
import {LinkButton} from '../../../../components/Interface/Forms/Buttons/LinkButton';
import {NotFound} from '../../../../components/Interface/Search/NotFound';
import {FilterItem, FilterItemText, FilterItemIcon, FilterItemRow, FilterItemInfo} from './filter-components.styles';

interface Props {
  categoria?: string;
  onSelectCategoria: (value: any) => void;
}

export default function FilterCategoryContent({categoria, onSelectCategoria}: Props) {
  const [search, setSearch] = useState('');
  const [filteredCategories, setFilteredCategories] = useState<string[]>([]);

  const formatCategory = (name: string) =>
    name
      .toLowerCase()
      .replace(/(^|\s)([A-Za-zÀ-ÿ])/g, (_, sep: string, char: string) => `${sep}${char.toUpperCase()}`);

  const handleSearchCategories = (name: string) => {
    const filter = parceiroCategorias.filter(e =>
      e
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );
    setFilteredCategories(filter);
    setSearch(name);
  };

  const displayCategories = search.length > 0 ? filteredCategories : parceiroCategorias;

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <View style={styles.container}>
        <SearchInput
          placeholder="Buscar categoria"
          value={search}
          autoCapitalize="sentences"
          onChangeText={handleSearchCategories}
        />
        <View style={{marginTop: RFValue(16), flexDirection: 'row',}}>
          <LinkButton
            text="Limpar filtro"
            enabled
            action={() => onSelectCategoria(undefined)}
          />
        </View>

        {displayCategories.length > 0 ? (
          <ScrollView
            scrollEnabled
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.content}>
            {displayCategories.map((cat, index) => (
              <FilterItem
                key={cat}
                style={{
                  borderBottomWidth:
                    index === displayCategories.length - 1 && displayCategories.length > 1 ? 0 : 1,
                }}
                onPress={() => onSelectCategoria(cat)}>
                <FilterItemRow>
                  <FilterItemInfo>
                    <FilterItemText active={cat === categoria}>{formatCategory(cat)}</FilterItemText>
                  </FilterItemInfo>
                  <FilterItemIcon name={cat === categoria ? 'check' : 'chevron-right'} />
                </FilterItemRow>
              </FilterItem>
            ))}
          </ScrollView>
        ) : (
          <View style={styles.notFound}>
            <NotFound />
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: RFValue(24),
    paddingVertical: RFValue(16),
    maxHeight: '98%',
  },
  content: {
    paddingVertical: RFValue(16),
  },
  notFound: {
    marginTop: RFValue(20),
  },
});
